import { Injectable } from '@angular/core';

import { Observable, combineLatest, map, share } from 'rxjs';

import { IPlaceBetErrorState, PlaceButtonBaseState, PlaceButtonExternalState } from '../../place-button.models';
import { PlaceButtonErrorStateService } from './place-button-error-state.service';
import { PlaceButtonExternalStateService } from './place-button-external-state.service';

@Injectable()
export class PlaceButtonBaseStateService {
    private state$: Observable<PlaceButtonBaseState>;

    constructor(externalStateService: PlaceButtonExternalStateService, errorStateService: PlaceButtonErrorStateService) {
        this.state$ = combineLatest([externalStateService.externalState$, errorStateService.errorState$]).pipe(
            map(([externalState, errorState]) => this.mapState(externalState, errorState)),
            share(),
        );
    }

    private mapState(externalState: PlaceButtonExternalState, errorState: IPlaceBetErrorState): PlaceButtonBaseState {
        return {
            externalState,
            errorState,
        };
    }

    get baseState$(): Observable<PlaceButtonBaseState> {
        return this.state$;
    }
}
